import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { User } from 'entities/User';
import { LOCAL_STORAGE_USER_KEY } from 'shared/consts/localStorage';
import { getIngressPath } from 'shared/lib/ingressPath';

const getToken = () => {
  try {
    const authData = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_USER_KEY) || '{}'
    ) as User;

    return authData.token || '';
  } catch {
    localStorage.removeItem(LOCAL_STORAGE_USER_KEY);
    return '';
  }
};

export const $rtkApi = createApi({
  reducerPath: 'rtkApi',
  tagTypes: ['UserInfo', 'ServiceProblemInfo'],
  baseQuery: fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: (headers) => {
      const token = getToken();

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      const ingressPath = getIngressPath();

      if (ingressPath) {
        headers.set('X-Ingress', ingressPath);
        headers.set('X-Pricing-Ingress', ingressPath);
      }

      return headers;
    },
  }),
  endpoints: () => ({}),
});
